import { apiSlice } from "../";
import { getToken } from "shared/utils/getToken";

export interface Informacao {
    titulo: string,
    conteudo: string,
    linkEdital: string
}

const informacaoSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getInformacao: builder.query<Informacao, void>({
            query: () => ({
                url: "informacao",
                method: "GET",
            }),
            providesTags: ["Informacao"]
        }),
        updateInformacao: builder.mutation<void, Informacao>({
            query: (data) => ({
                url: "informacao",
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
                body: {
                    titulo: data.titulo,
                    conteudo: data.conteudo,
                    linkEdital: data.linkEdital
                }
            })
        })
    })
})

export const {
    useGetInformacaoQuery,
    useUpdateInformacaoMutation
} = informacaoSlice